// src/pages/admin/RaiseFunds.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";

// ฟอร์ม “เชิญประชุมอนุมัติจ่ายเงินปันผล”
import RaiseFundsForm from "../../forms/business/RaiseFunds/RaiseFunds";

function RaiseFundsPage() {
  return (
    <FormWrapper
      title="เพิ่มทุน"
      FormComponent={RaiseFundsForm}
      formKey="RaiseFunds"
    />
  );
}

export default RaiseFundsPage;
